import { Link, useHistory } from "react-router-dom";
import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { findByLabelText } from "@testing-library/react";

export default function NavbarAttendance() {
  const history = useHistory();
  const [error, setError] = useState("");
  const { currentUser, logout } = useAuth();

  async function handleLogout() {
    setError("");

    try {
      await logout();
      history.push("/login");
    } catch {
      setError("Failed to log out");
    }
  }

  function GoToShop() {
    history.push("/Shop");
  }

  return (
    <div>
      <div className="Navbar">
        {/* Närvaro */}
        <div
          className="PageSwitch"
          onClick={GoToShop}
          style={{ width: "100px", margin: "0", display: "block" }}
        >
          Shop
        </div>
        <div className="PageSwitch float-right" onClick={handleLogout}>
          Logga ut
        </div>
      </div>
      <div className="SearchBar">
        <input type="text" name="" id="" placeholder="Sök..." />
      </div>
    </div>
  );
}
